export const ticketSaleSteps = {
	payment: 'PAYMENT',
	confirmation: 'CONFIRMATION',
	busSeatSelectionGoing: 'BUS_SEAT_SELECTION_GOING',
	busSeatSelectionReturn: 'BUS_SEAT_SELECTION_RETURN',
}

export const purchaseOption = {
	value: 2,
	points: 0,
	pointsValue: 1,
}

export const PaymentStatus = {
	CANCELLED: 'Cancelado',
	PAID: 'Pago',
	REBOOKING: 'Remarcado',
}

export const tripsDirections = {
	IDA: 'IDA',
	VOLTA: 'VOLTA',
}
